const muiOutlinedInput = (theme) => {
  return {
    MuiOutlinedInput: {
      defaultProps: {},

      styleOverrides: {
        root: {},

        sizeSmall: {
          height: '40px',
        },

        input: {
          padding: 0,
          paddingLeft: '16px',
          height: '48px',
          fontSize: '14px',
          lineHeight: '17.71px',
          fontWeight: 400,
        },

        inputMultiline: {
          padding: 0,
        },

        inputSizeSmall: {
          fontSize: '12px',
          lineHeight: '15.18px',
          fontWeight: 400,
        },
      },
    },
  };
};

export default muiOutlinedInput;
